import LogoHeader from "../elements/LogoHeader";
import DynamicNav from "../../nav/DynamicNav";
import {Link, useLocation} from "react-router-dom";
import React from "react";

export default function Desktop() {
  const location = useLocation();
  const navLinks = [
    { src: null, url: "#section-2", text: "How it works" },
    { src: null, url: "#section-3", text: "Why choose us" },
    { src: null, url: "#section-5", text: "Pricing" },
    { src: null, url: "#section-6", text: "Security" },
  ];

  // Hide DynamicNav on login, register, and forgot-password pages
  const hiddenPaths = ['/login', '/register', '/forgot-password'];
  const shouldHideNav = hiddenPaths.some(path => location.pathname.includes(path));

  return (
    <div className="xl:container md:px-4 xl:px-16 xxl:px-0 xxl:mx-auto mobile:hidden py-5">
      <div className="grid" style={{ gridTemplateColumns: '1fr 2fr 1fr' }}>
        <div className="">
          <LogoHeader />
        </div>
        <div className="flex justify-end xl:gap-x-4 xxl:gap-x-12">
          {!shouldHideNav && <DynamicNav links={navLinks} navigateTo={true} />}
        </div>
        <div className="flex justify-end items-center">
          <div className="flex p-myCustomP1 items-center">
            <img className="h-4 mr-2" src={`${process.env.PUBLIC_URL}/login-ico.svg`}  alt="login-ico"/>
            <a href="/login" className="text-secondary hover:text-secondary ">
              Login
            </a>
          </div>
          <Link to={`register`} className={`w-[175px] h-[35px] rounded-[25px] bg-secondary flex items-center justify-center`}>
            <p className={`text-white text-center`}>Create account</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
